module.exports = __webpack_public_path__ + "img/customer_2_de.e580206e.png";